import { render, staticRenderFns } from "./energy.vue?vue&type=template&id=ecd41e16&scoped=true"
import script from "./energy.vue?vue&type=script&lang=js"
export * from "./energy.vue?vue&type=script&lang=js"
import style0 from "./energy.vue?vue&type=style&index=0&id=ecd41e16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd41e16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecd41e16')) {
      api.createRecord('ecd41e16', component.options)
    } else {
      api.reload('ecd41e16', component.options)
    }
    module.hot.accept("./energy.vue?vue&type=template&id=ecd41e16&scoped=true", function () {
      api.rerender('ecd41e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents/energy.vue"
export default component.exports